/** What the listener needs of the window, so a test can hand it a small stand-in. */
export interface ResizeWindow {
  readonly innerWidth: number;
  addEventListener(type: "resize", listener: (event: { stopImmediatePropagation(): void }) => void, options: { capture: boolean }): void;
}

/**
 * In a host the frame grows with its page, so the window changes height each time the page does. Radix closes an open dropdown on any resize
 * of the window: one opened just as a page settled closed by itself. Only a change of width is something the person did.
 * Call it before anything renders, so this listener comes first. Nothing in the app depends on the height of the window in a frame: the part
 * of the host's page a person can see comes from the host, as `imagora:viewport`.
 */
export function ignoreHeightOnlyResizes(win: ResizeWindow): void {
  let width = win.innerWidth;
  win.addEventListener(
    "resize",
    (event) => {
      if (win.innerWidth === width) event.stopImmediatePropagation();
      width = win.innerWidth;
    },
    { capture: true },
  );
}
